import './styles/iconStyles.css';

const PantheorIcon = (props) => (
  <svg
    className="inline h-7 pantheorIconStyles"
    viewBox="0 0 14 34"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.6 0l3.12 7.34H.76l1.3 3.1h8.03L1.61 0zm10.5 26.3l-1.3-3.1H8.96l-.04-.08-2.54-6H4.9l2.58 6.09h-4.7l8.48 10.44-3.11-7.35h3.96zM6.7 16.34h2.69l-2.34-5.5h-5.8c-.45 0-.7 0-.9.63-.23.77-.34 2.36-.34 5.16 0 2.8.1 4.4.35 5.16.2.64.44.64.88.64H6.5l-2.58-6.1h2.13l-1.3-3.04h.65l1.29 3.05zm6.51 3.63H8.23l1.04 2.46h3.93c.1 0 .33-.12.33-1.23 0-1.1-.23-1.23-.33-1.23zm0-6.68c.1 0 .33-.12.33-1.23 0-1.1-.23-1.22-.33-1.22H7.7l1.04 2.45h4.47zm.46 3.64H6.94l1.04 2.45h5.68c.1 0 .33-.12.33-1.23 0-1.1-.23-1.22-.33-1.22zm0-3.05H8.98l1.04 2.46h3.64c.1 0 .33-.12.33-1.23 0-1.11-.23-1.23-.33-1.23z"
      fill="#600C58"
      fillRule="evenodd"
    />
  </svg>
);

export default PantheorIcon;
